import React from 'react';
import { motion } from 'framer-motion';
import { useCopy } from './copy/copyMode';
const TESTIMONIALS = [{
  name: 'Deedy',
  handle: '@deedydas',
  avatar: 'https://cdn.magicpatterns.com/uploads/5W6MAupD98wvFiYp41fJMf/Group_86.png',
  text: "I use ~5 AI agents regularly that saves me many hours. Giga handles all the Slack noise and recaps so I don't have to."
}, {
  name: 'Linus Ekenstam',
  handle: '@LinusEkenstam',
  avatar: 'https://cdn.magicpatterns.com/uploads/2WgepSFX3CkY6pR5kePvSf/Group_87.png',
  text: 'Giga is like having a chief of staff in Slack. It manages my updates, recaps meetings, and finds docs instantly.'
}, {
  name: 'Chase Dimond',
  handle: '@ecomchasedimond',
  avatar: 'https://cdn.magicpatterns.com/uploads/uyh8VRndoHvMqN8QCTyAa9/Rectangle_(9).png',
  bg: '#EA580C',
  text: "While you're stuck in status meetings, someone just automated their entire follow-up process with Giga."
}, {
  name: 'Kalsoom',
  handle: '@AlwithGhotai',
  avatar: 'https://cdn.magicpatterns.com/uploads/mxjsJUukXbd5KgEa6Do1cq/Rectangle_(10).png',
  bg: '#EA580C',
  text: 'I used to spend 4 hours daily on admin tasks. Giga now handles all of this in Slack while I sleep. Productivity increased 400%.'
}, {
  name: 'Sarah',
  handle: '@sarah_builds',
  avatar: 'https://cdn.magicpatterns.com/uploads/fqb6myvdEu9UD2zwQT9tZH/Group_85.png',
  text: "The advanced recall feature is insane. I just ask Giga 'what did we decide about X' and it pulls the exact Slack thread."
}];
export function WallOfLove() {
  const copy = useCopy();
  return <section className="relative w-full bg-[#FAF8F4] py-12 md:py-32 overflow-hidden" data-id="element-2652">
      {/* Subtle grid texture */}
      <div className="absolute inset-0 dot-matrix opacity-50 pointer-events-none" data-id="element-2653" />

      <div className="relative z-10 max-w-[1280px] mx-auto px-6 md:px-10 mb-12 md:mb-16 text-center" data-id="element-2654">
        <span className="block text-xs font-semibold tracking-[5px] uppercase text-neutral-400 mb-5 md:mb-6" data-id="element-2655">
          WALL OF LOVE
        </span>
        <h2 className="text-3xl md:text-5xl font-title font-medium text-[#2B211A] tracking-tight leading-[1.1] max-w-3xl mx-auto" data-id="element-2656">
          {copy.wallOfLove.headline}
        </h2>
      </div>

      {/* Scroller */}
      <div className="relative z-10 w-full flex overflow-x-hidden" data-id="element-2657">
        <motion.div animate={{
        x: ['0%', '-50%']
      }} transition={{
        duration: 40,
        ease: 'linear',
        repeat: Infinity
      }} className="flex gap-6 px-6 w-max" data-id="element-2658">
          {[...TESTIMONIALS, ...TESTIMONIALS].map((t, i) => <div key={i} className="w-[380px] bg-white rounded-3xl p-8 border border-neutral-200 shadow-sm shrink-0 flex flex-col" data-id="element-2659">
              <div className="flex items-center gap-4 mb-5" data-id="element-2660">
                <div className="w-12 h-12 rounded-full overflow-hidden shrink-0" style={{
              backgroundColor: (t as any).bg || 'transparent'
            }} data-id="element-2661">
                  <img src={t.avatar} alt={t.name} className="w-full h-full rounded-full object-cover" data-id="element-2662" />
                </div>
                <div data-id="element-2663">
                  <div className="font-bold text-[#2B211A] text-base" data-id="element-2664">
                    {t.name}
                  </div>
                  <div className="text-sm text-[#EA580C]" data-id="element-2665">{t.handle}</div>
                </div>
              </div>
              <p className="text-[15px] text-neutral-600 leading-relaxed" data-id="element-2666">
                {t.text}
              </p>
            </div>)}
        </motion.div>
      </div>
    </section>;
}